import { useCopyToClipboard } from 'react-use';

import { CheckIcon, CopyIcon } from '@air/design-icons';

export type CustomFieldFormAPIInformationCopyValueProps = {
  id: string;
};

export const CustomFieldFormAPIInformationCopyValue = ({ id }: CustomFieldFormAPIInformationCopyValueProps) => {
  const [state, copyToClipboard] = useCopyToClipboard();

  return (
    <div className="group/custom-field-api-value inline-flex gap-1">
      <button
        className="select-all ads:text-metadata text-12 text-gray-9"
        // biome-ignore lint/performance/noJsxPropsBind: copy writes this field's id to the clipboard
        onClick={() => copyToClipboard(id)}
        type="button"
      >
        {id}
      </button>

      {state.value ? (
        <CheckIcon className="ads:text-icon-primary text-blue-9" size="sm" />
      ) : (
        <CopyIcon
          className="hidden ads:text-icon-subtle text-gray-9 group-hover/custom-field-api-value:block"
          size="sm"
        />
      )}
    </div>
  );
};
